import MoltenMetal from './MoltenMetal';

export function PageBackdrop() {
  return (
    <div className="page-backdrop" aria-hidden>
      <MoltenMetal
        color1="#2C2C4A"
        color2="#585DEF"
        color3="#CAA97D"
        speed={0.18}
        scale={2.8}
        detail={3}
        glow={1.45}
        coreSize={0.095}
        swirl={0.9}
        fold={-0.2}
        blackPoint={0.06}
        brightness={1.15}
        colorMode="molten"
        grain
        grainIntensity={0.035}
        mouseInteraction
        mouseStrength={0.2}
        opacity={0.55}
      />
    </div>
  );
}
